import React from 'react';
import { Link } from 'react-router-dom';
import { Sun, Phone, Mail, MapPin, Facebook, Instagram, Linkedin, MessageCircle } from 'lucide-react';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-[#0D47A1] text-white">
      <div className="max-w-7xl mx-auto px-6 py-12">
        <div className="grid md:grid-cols-4 gap-8">
          {/* Company Info */}
          <div>
            <div className="flex items-center gap-2 mb-4">
              <Sun className="w-8 h-8 text-[#FFC107]" />
              <h3 className="text-xl font-bold">Yours Energy Solutions</h3>
            </div>
            <p className="text-gray-300 mb-4 leading-relaxed">
              All solar products and services under one roof. Powering a greener future for India.
            </p>
            <div className="flex gap-4">
              <a href="#" className="hover:text-[#FFC107] transition-colors" aria-label="Facebook">
                <Facebook className="w-5 h-5" />
              </a>
              <a href="#" className="hover:text-[#FFC107] transition-colors" aria-label="Instagram">
                <Instagram className="w-5 h-5" />
              </a>
              <a href="#" className="hover:text-[#FFC107] transition-colors" aria-label="LinkedIn">
                <Linkedin className="w-5 h-5" />
              </a>
              {/* WhatsApp */}
              <a
                href="https://wa.me/918822367580"
                target="_blank"
                rel="noopener noreferrer"
                className="hover:text-[#25D366] transition-colors"
                aria-label="WhatsApp"
              >
                <MessageCircle className="w-5 h-5" />
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="text-lg font-bold mb-4">Quick Links</h3>
            <ul className="space-y-2">
              <li><Link to="/" className="text-gray-300 hover:text-[#FFC107] transition-colors">Home</Link></li>
              <li><Link to="/about" className="text-gray-300 hover:text-[#FFC107] transition-colors">About Us</Link></li>
              <li><Link to="/services" className="text-gray-300 hover:text-[#FFC107] transition-colors">Services</Link></li>
              <li><Link to="/projects" className="text-gray-300 hover:text-[#FFC107] transition-colors">Projects</Link></li>
              <li><Link to="/contact" className="text-gray-300 hover:text-[#FFC107] transition-colors">Contact</Link></li>
            </ul>
          </div>

          {/* Services */}
          <div>
            <h3 className="text-lg font-bold mb-4">Our Services</h3>
            <ul className="space-y-2 text-gray-300">
              <li>Residential Solar Systems</li>
              <li>Commercial Solar Solutions</li>
              <li>Solar Street Lights</li>
              <li>Solar Water Heaters</li>
              <li>Maintenance & AMC</li>
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h3 className="text-lg font-bold mb-4">Contact Us</h3>
            <ul className="space-y-3 text-gray-300">
              <li className="flex items-start gap-2">
                <Phone className="w-5 h-5 text-[#FFC107] flex-shrink-0 mt-0.5" />
                <span>
                  Mobile / WhatsApp: <br />
                  <a href="https://wa.me/918822367580" target="_blank" rel="noopener noreferrer" className="hover:text-[#25D366]">
                    +91 8822367580
                  </a>, 9401990674
                </span>
              </li>
              <li className="flex items-start gap-2">
                <Mail className="w-5 h-5 text-[#FFC107] flex-shrink-0 mt-0.5" />
                <span className="text-sm">info@yoursenergies.com</span>
              </li>
              <li className="flex items-start gap-2">
                <MapPin className="w-5 h-5 text-[#FFC107] flex-shrink-0 mt-0.5" />
                <span className="text-sm">
                  <strong>Head Office:</strong> Beltola, Guwahati<br />
                  <strong>Branch Office:</strong> Old Amulapatty, Sivsagar
                </span>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-gray-700 mt-8 pt-8 text-center">
          <p className="text-gray-300">
            &copy; {currentYear} Yours Energy Solutions. All rights reserved.
          </p>
          <p className="text-gray-400 text-sm mt-2">
            Trusted Solar Solutions Provider in India
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
